export const configFileURL = '/siteconfig/AppConfig.json';

